import React from 'react';
import PropTypes from 'prop-types';
import AttachmentsBlock from './AttachmentsBlock';

export const FileAttachment = ({
  attachToUri,
  editable,
  isLoading,
  customMetadataFn,
  ariaAttributes,
  AttachmentStatusComponent,
  AttachmentStatusActionComponent,
  refetchQueries,
  onGetAttachmentsCompleted
}) => (
  <AttachmentsBlock
    key="attachments"
    isLoadingDetails={isLoading}
    attachToUri={attachToUri}
    editable={editable}
    customMetadataFn={customMetadataFn}
    ariaAttributes={ariaAttributes}
    AttachmentStatusComponent={AttachmentStatusComponent}
    AttachmentStatusActionComponent={AttachmentStatusActionComponent}
    refetchQueries={refetchQueries}
    onGetAttachmentsCompleted={onGetAttachmentsCompleted}
  />
);

FileAttachment.propTypes = {
  attachToUri: PropTypes.string,
  editable: PropTypes.bool,
  isLoading: PropTypes.bool,
  customMetadataFn: PropTypes.func,
  ariaAttributes: PropTypes.object,
  AttachmentStatusComponent: PropTypes.func,
  AttachmentStatusActionComponent: PropTypes.func,
  refetchQueries: PropTypes.array,
  onGetAttachmentsCompleted: PropTypes.func
};

export default FileAttachment;
